import { createBlock as l, openBlock as r, unref as a, withCtx as s, createElementVNode as n, createVNode as i, createElementBlock as m, createCommentVNode as u, toDisplayString as o } from "vue";
import { useTracking as g } from "../../composables/useTracking.js";
/* empty css               */
import x from "../../_virtual/_plugin-vue_export-helper.js";
import w from "../../atoms/anchor-element/anchor-element.vue.js";
import c from "../../atoms/icon/icon.vue.js";
const f = { class: "card__content-wrapper" }, k = { class: "card__icons" }, y = { class: "card__text" }, _ = {
  class: "ds-heading-xsmall",
  "data-j-title": ""
}, h = {
  key: 0,
  class: "ds-text ds-margin-top-4",
  "data-j-text": ""
}, d = "DsCardIcon", p = /* @__PURE__ */ Object.assign({
  name: d
}, {
  __name: "card-icon",
  props: {
    link: {
      type: Object,
      required: !0,
      validator: (t) => ["title", "url", "openInNewWindow", "nuxt"].every((e) => e in t)
    },
    icon: {
      type: Object,
      required: !0,
      validator: (t) => ["name", "category"].every((e) => e in t)
    },
    title: {
      type: String,
      required: !0
    },
    text: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const { trackingDataProvided: e } = g();
    return (v, j) => (r(), l(a(w), {
      class: "card",
      "tracking-data": { "component-name": d, text: t.title, ...a(e) },
      url: t.link.url,
      "open-in-new-window": t.link.openInNewWindow,
      nuxt: t.link.nuxt,
      "aria-label": t.link.title,
      "data-j-link": ""
    }, {
      default: s(() => [
        n("div", f, [
          n("div", k, [
            i(a(c), {
              category: t.icon.category,
              name: t.icon.name,
              "data-j-icon": ""
            }, null, 8, ["category", "name"]),
            i(a(c), {
              class: "ds-color-green",
              category: "arrows",
              name: "arrow-right",
              "data-j-arrow": ""
            })
          ]),
          n("div", y, [
            n("h3", _, o(t.title), 1),
            t.text ? (r(), m("p", h, o(t.text), 1)) : u("", !0)
          ])
        ])
      ]),
      _: 1
    }, 8, ["tracking-data", "url", "open-in-new-window", "nuxt", "aria-label"]));
  }
}), D = /* @__PURE__ */ x(p, [["__scopeId", "data-v-3cb0f83a"]]);
export {
  D as default
};
